import { CreateNodeBody } from "@/@types/ivr";
import { ActionType, NodeType } from "@/app/ivr/bot/utils/enums";

const baseBody: Partial<CreateNodeBody> = {
  action: undefined,
  name_numerical_dialing: undefined,
  file_audio: undefined,
  wait_answer: false,
  time_waiting: undefined,
  option: undefined,
  variable_name: undefined,
  before_end_call_file_audio: undefined,
  has_validation: false,
  max_digit_answer: undefined,
  max_attempts: undefined,
  max_attempts_action: undefined,
  wrong_answer_file_audio: undefined,
  end_call_file_audio: undefined,
  node_to_back: undefined,
  back_to_node_file_audio: undefined,
  portfolio: undefined,
  queue: undefined,
  whatsapp_template: undefined,
  whatsapp_template_audio: undefined,
  back_to_node: undefined,
  order: 1,
  satisfaction_ranking_start: undefined,
  satisfaction_ranking_end: undefined,
  waiting_file_audio: undefined,
  node: undefined,
  type: NodeType.NumericDialing,
};

export const NumericDialing: Partial<CreateNodeBody> = {
  ...baseBody,
  // action: ActionType.EndCall,
  // name_numerical_dialing: "",
  type: NodeType.NumericDialing,
};

export const Option: Partial<CreateNodeBody> = {
  ...baseBody,
  action: ActionType.EndCall,
  option: "0",
  type: NodeType.Option,
};

export const WrongOption: Partial<CreateNodeBody> = {
  ...baseBody,
  action: ActionType.EndCall,
  max_attempts_action: ActionType.EndCall,
  type: NodeType.WrongOption,
  order: 99,
};

export const VariableCapture: Partial<CreateNodeBody> = {
  ...baseBody,
  action: ActionType.EndCall,
  variable_name: "",
  type: NodeType.VariableCapture,
};

export const SatisfactionRanking: Partial<CreateNodeBody> = {
  ...baseBody,
  action: ActionType.EndCall,
  wait_answer: true,
  time_waiting: 30,
  satisfaction_ranking_start: 1,
  satisfaction_ranking_end: 9,
  type: NodeType.SatisfactionRanking,
};

export const ExpiredTime: Partial<CreateNodeBody> = {
  ...baseBody,
  order: 100,
  time_waiting: 3,
  action: ActionType.EndCall,
  type: NodeType.ExpiredTime,
};

export const WrongOptionApi: Partial<CreateNodeBody> = {
  ...baseBody,
  action: ActionType.EndCall,
  max_attempts_action: ActionType.EndCall,
  type: NodeType.WrongOptionApi,
  order: 99,
};

export const OptionConsultApi: Partial<CreateNodeBody> = {
  ...baseBody,
  action: ActionType.EndCall,
  option: "0",
  type: NodeType.OptionConsultApi,
};
